"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _templateObject;
var Title = _styledComponents["default"].span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 1.5em;\n  margin: 0;\n  margin-bottom: ", ";\n  line-height: normal;\n  display: block;\n"])), function (_ref) {
  var marginBottom = _ref.marginBottom;
  return marginBottom;
});
Title.propTypes = {
  marginBottom: _propTypes["default"].string
}, Title.defaultProps = {
  marginBottom: '1em'
};
var _default = exports["default"] = Title;